import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { postFetcherForRegister } from "../../../api/fetchers";
import { useNavigate } from "react-router-dom";
import { endpoints } from "../../../api/endpoints";
import RegisterPromotionMan from "../../assets/images/human.png";
// import Footer from "../../components/footer/Footer";
// import Header from "../../components/header/Header";
// import Navbar from "../../components/navbar/Navbar";
// import citiesData from "../../data/cities.json";
import { useUser } from "../../context/UserContext";
import { parseStatics } from "../../function/parseStatics";
import { useLanguage } from "../../context/LanguageContext";

// interface District {
//   value: number;
//   district: string;
// }

const Register: React.FC = () => {
  const { t } = useLanguage();
  const { falseShowLoginPopup } = useUser();
  const [error, setError] = useState("");
  console.log(error);
//const [districts, setDistricts] = useState<District[]>([]);
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      name: "",
      surname: "",
      email: "",
      phone: "",
      identityNo: "",
      address: "",
      city: "",
      district: "",
      refCode: "",
      companyName: "",
      taxNumber: "",
      taxOffice: "",
      kepAddress: "",
      //businessPackageId: { id: "", name: "" },
      password: "",
      confirmPassword: "",
      status: false,
      statusTwo: false,
      prk: true
    },
    onSubmit: async (values) => {

      if (!values.status || !values.statusTwo) {
        toast.error(t("toastMessage", "r1"), {
          hideProgressBar: true,
        });
        return;
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
        toast.error(t("toastMessage", "r2"), {
          hideProgressBar: true,
        });
        return;
      } else if (values.phone.length < 9) {
        toast.error(t("toastMessage", "r3"), {
          hideProgressBar: true,
        });
        return;
      // } else if (values.identityNo.length < 10) {
      //   toast.error(t("toastMessage", "r4"), {
      //     hideProgressBar: true,
      //   });
      //   return;
      } else if (values.password != values.confirmPassword) {
        toast.error(t("toastMessage", "r5"), {
          hideProgressBar: true,
        });
        return;
        
      } else {
        setError("");
        const result = await postFetcherForRegister(endpoints.auth.register, {
          arg: {
            firstName: values.name, //
            lastName: values.surname, //
            email: values.email, //
            phoneNumber: values.phone, //
            password: values.password, //
            profilePicture: "", //
            openAddress:values.city + ' / ' + values.district + ', ' + values.address, //
            referenceCode: values.refCode, //
            companyName: values.companyName, //
            identityNo: '1111', //
            taxNumber: values.taxNumber, //
            taxOffice: values.taxOffice, //
            kepAddress: values.kepAddress, //
            businessPackageId: "10",
            city: values.city,
            district: values.district,
            status: false,
            prk: values.prk,
          },
        });
        if (typeof result === "string") {
          setError(result);
          toast.error(t("toastMessage", "r7"), {
            hideProgressBar: true,
          });
          localStorage.removeItem("formData");
        } else {
          toast.success(t("toastMessage", "r8"), {
            hideProgressBar: true,
          });
          localStorage.removeItem("formData");
          localStorage.setItem("user", JSON.stringify(values));
          falseShowLoginPopup();
          setTimeout(() => {
            navigate("/");
          }, 2000);
        }
      }
    },
  });

  useEffect(() => {
    const savedStatus = localStorage.getItem("checkboxStatus");
    if (savedStatus === "true") {
      formik.setFieldValue("status", true);
    }
  }, []);

  useEffect(() => {
    const savedStatus = localStorage.getItem("checkboxStatus2");
    if (savedStatus === "true") {
      formik.setFieldValue("statusTwo", true);
    }
  }, []);

  const handleNavigate1 = (path: string) => {
    formik.setFieldValue("status", true);
    localStorage.setItem("checkboxStatus", "true");
    localStorage.setItem("formData", JSON.stringify(formik.values));
    navigate(path);
  };

  const handleNavigate2 = (path: string) => {
    formik.setFieldValue("statusTwo", true);
    localStorage.setItem("checkboxStatus2", "true");
    localStorage.setItem("formData", JSON.stringify(formik.values));
    navigate(path);
  };

  useEffect(() => {
    const savedFormData = localStorage.getItem("formData");
    if (savedFormData) {
      formik.setValues(parseStatics(savedFormData));
    }
    const savedStatus = localStorage.getItem("checkboxStatus");
    if (savedStatus === "true") {
      formik.setFieldValue("status", true);
    } else {
      formik.setFieldValue("status", false);
    }
  }, []);

  useEffect(() => {
    const savedStatusTwo = localStorage.getItem("checkboxStatus2");
    if (savedStatusTwo === "true") {
      formik.setFieldValue("statusTwo", true);
    } else {
      formik.setFieldValue("statusTwo", false);
    }
  }, []);

  const handleCitySelect = (value: any) => {
    formik.setFieldValue("city", value);
    // const selectedCityData: any = citiesData.find(
    //   (city: any) => city.value.toString() === value.toString()
    // );
    // // setDistricts(selectedCityData?.districts);
    // formik.setFieldValue("district", "");
  };
  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {/* <Header />
            <Navbar /> */}
      <form className="-mt-10" onSubmit={formik.handleSubmit}>
        <div className="flex w-full h-[500px] bg-white justify-center items-center ">
          <div className="px-4">
            <p className="text-3xl font-poppins">
              <p className="font-bold font-poppins">{t("register", "title")}</p>
              {t("register", "text1")}
            </p>
            <br></br>
            <a className="font-poppins text-sm">
              {t("register", "text2")}
              <br></br>
              {t("register", "text3")}
            </a>
            <br></br>
            <br></br>
            <a className="font-bold font-poppins text-3xl">Novamed</a>{" "}
            <a className="font-bold font-poppins text-[#FFC633] text-3xl">
              Shop
            </a>
          </div>
          <img
            src={RegisterPromotionMan}
            className="h-[300px] w-[500px] object-cover hidden md:flex"
          ></img>
        </div>

        <div className="mx-auto container justify-center items-center px-4 sm:px-[17%]">
          <p className="text-xl font-poppins font-bold text-[#FFC633]">
            {t("register", "person")}
          </p>

          <div className="flex md:flex-row flex-col justify-between mt-8">
            <input
              type="text"
              id="name"
              className="md:w-[47.5%] border-2 px-4 rounded-md h-12"
              placeholder={t("register", "f1")}
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              required
            ></input>
            {/*formik.touched.name && formik.errors.name ? (
                            <div className="text-red-400 text-[12px] mt-[-15px] ml-1">
                                {formik.errors.name}
                            </div>
                        ) : null*/}

            <input
              className="md:w-[47.5%] mt-4 md:mt-0 border-2 px-4 rounded-md h-12"
              type="text"
              id="surname"
              name="surname"
              placeholder={t("register", "f2")}
              value={formik.values.surname}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              required
            ></input>
          </div>

          <div className="flex md:flex-row flex-col justify-between mt-4">
            <input
              className="md:w-[47.5%] border-2 px-4 rounded-md h-12"
              placeholder={t("register", "f3")}
              type="email"
              id="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              required
            ></input>

            <div className="md:w-[47.5%] mt-4 md:mt-0">
              <input
                className="w-full border-2 px-4 rounded-md h-12"
                type="text"
                id="phone"
                name="phone"
                placeholder={t("register", "f4")}
                maxLength={40}
                value={formik.values.phone}
                onChange={formik.handleChange}
                required
              ></input>
              {/* <p className="text-[12px] text-gray-700 ml-1 font-sans">
                (Lütfen başında 0 olmadan giriniz.)
              </p> */}
            </div>
          </div>

          {/* <div className="flex md:flex-row flex-col justify-between mt-4">
            <input
              className="md:w-[47.5%] border-2 px-4 rounded-md h-12"
              placeholder={t("register", "f5")}
              type="text"
              id="identityNo"
              name="identityNo"
              maxLength={40}
              value={formik.values.identityNo}
              onChange={formik.handleChange}
              required
            ></input>
          </div> */}
        </div>

        <div className="mx-auto container justify-center items-center px-4 sm:px-[17%] mt-10">
          <p className="text-xl font-poppins font-bold text-[#FFC633]">
            {t("register", "address")}
          </p>

          <div className=" flex flex-col mt-8 ">
            {/* <div className="flex  gap-4 w-full justify-between">
                            <select
                                id="city"
                                name="city"
                                //value={formik.values.city}
                                onChange={(event) => {
                                    formik.handleChange(event.target.value);
                                    handleCitySelect(event.target.value);
                                }}
                                onBlur={formik.handleBlur}
                                className="border border-gray-300 p-2 rounded-md w-full"
                            >
                                <option>{t('register', 'f6')}</option>
                                {citiesData?.map((city) => (
                                    <option key={city.value} value={JSON.stringify(city.value)}>
                                        {city.city}
                                    </option>
                                ))}
                            </select>
                            <select
                                id="district"
                                name="district"
                                //value={formik.values.district}
                                onChange={(event) => {
                                    formik.handleChange(event.target.value);
                                    formik.setFieldValue("district", event.target.value);
                                }}
                                onBlur={formik.handleBlur}
                                className="border border-gray-300 p-2 rounded-md w-full"
                            >
                                <option>{t('register', 'f7')}</option>
                                {districts.map((item: any, index: React.Key | number) => {
                                    return (
                                        <option key={index} value={item?.district}>
                                            {item?.district}
                                        </option>
                                    );
                                })}
                            </select>
                        </div> */}

            <div className="flex gap-4 w-full justify-between">
              <input
                id="city"
                name="city"
                type="text"
                placeholder={t("register", "f6")}
                onChange={(event) => {
                  formik.handleChange(event.target.value);
                  handleCitySelect(event.target.value);
                }}
                onBlur={formik.handleBlur}
                className="border border-gray-300 p-2 rounded-md w-full"
              />
              <input
                id="district"
                name="district"
                type="text"
                placeholder={t("register", "f7")}
                onChange={(event) => {
                  formik.handleChange(event.target.value);
                  formik.setFieldValue("district", event.target.value);
                }}
                onBlur={formik.handleBlur}
                className="border border-gray-300 p-2 rounded-md w-full"
              />
            </div>

            <div className="flex  w-full mt-4 ">
              <input
                className="w-full border-2 px-4 rounded-md h-12"
                placeholder={t("register", "f8")}
                type="text"
                id="address"
                name="address"
                value={formik.values.address}
                onChange={formik.handleChange}
                required
              ></input>
            </div>
          </div>
        </div>

        {/* <div className="mx-auto container justify-center items-center px-4 sm:px-[17%] mt-10">
          <p className="text-xl font-poppins font-bold text-[#FFC633]">
            {t("register", "company")}
            <a className="text-sm">( {t("register", "companyZ")} )</a>
          </p>

          <div className="flex md:flex-row flex-col justify-between mt-8">
            <input
              className="md:w-[47.5%] border-2 px-4 rounded-md h-12"
              placeholder={t("register", "f9")}
              type="text"
              id="companyName"
              name="companyName"
              value={formik.values.companyName}
              onChange={formik.handleChange}
            ></input>

            <input
              className="md:w-[47.5%] mt-4 md:mt-0 border-2 px-4 rounded-md h-12"
              placeholder={t("register", "f10")}
              type="text"
              id="taxNumber"
              name="taxNumber"
              value={formik.values.taxNumber}
              onChange={formik.handleChange}
            ></input>
          </div>

          <div className="flex md:flex-row flex-col justify-between mt-8">
            <input
              className="md:w-[47.5%] border-2 px-4 rounded-md h-12"
              placeholder={t("register", "f11")}
              type="text"
              id="taxOffice"
              name="taxOffice"
              value={formik.values.taxOffice}
              onChange={formik.handleChange}
            ></input>

            <input
              className="md:w-[47.5%] mt-4 md:mt-0 border-2 px-4 rounded-md h-12"
              placeholder={t("register", "f12")}
              type="text"
              id="kepAddress"
              name="kepAddress"
              value={formik.values.kepAddress}
              onChange={formik.handleChange}
            ></input>
          </div>
        </div> */}

        <div className="mx-auto container justify-center items-center px-4 sm:px-[17%] mt-10">
          <p className="text-xl font-poppins font-bold text-[#FFC633]">
            {t("register", "accound")}
          </p>
          <div className="flex md:flex-row flex-col justify-between mt-8">
            <input
              className="md:w-[47.5%] border-2 px-4 rounded-md h-12"
              placeholder={t("register", "f13")}
              type="text"
              id="refCode"
              name="refCode"
              value={formik.values.refCode}
              onChange={formik.handleChange}
            ></input>
          </div>
          <div className="flex md:flex-row flex-col justify-between mt-8">
            <input
              className="md:w-[47.5%] border-2 px-4 rounded-md h-12"
              placeholder={t("register", "f14")}
              type="password"
              id="password"
              name="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              required
            ></input>
            <input
              className="md:w-[47.5%] mt-4 md:mt-0 border-2 px-4 rounded-md h-12"
              placeholder={t("register", "f15")}
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              required
            ></input>
          </div>

          <div className="mt-6 flex flex-col gap-4 my-8">
            <div className="flex items-center">
              <input
                id="status"
                name="status"
                type="checkbox"
                className={`mr-2 focus:ring-primary-color ${
                  formik.values.status ? "text-primary-color" : ""
                }`}
                checked={formik.values.status}
                onChange={(e: any) => {
                  formik.handleChange(e);
                  localStorage.setItem("checkboxStatus", e.target.checked);
                }}
              />
              <label className="text-gray-600 text-sm">
                <span
                  onClick={() =>
                    handleNavigate1("/contracts/privacy_and_security_policy")
                  }
                >
                  {t("register", "p1")}
                </span>
              </label>
            </div>
            {formik.touched.status && formik.errors.status ? (
              <div className="text-red-400 text-[12px] mt-[-15px] ml-1">
                {formik.errors.status}
              </div>
            ) : null}
            <div className="flex items-center">
              <input
                id="statusTwo"
                name="statusTwo"
                type="checkbox"
                className={`mr-2 focus:ring-primary-color ${
                  formik.values.statusTwo ? "text-primary-color" : ""
                }`}
                onChange={(e: any) => {
                  formik.handleChange(e);
                  localStorage.setItem("checkboxStatus2", e.target.checked);
                }}
              />
              <label className="text-gray-600 text-sm">
                <span
                  onClick={() =>
                    handleNavigate2("/contracts/distance_selling_contract")
                  }
                >
                  {t("register", "p2")}
                </span>
              </label>
            </div>
            {/* {formik.touched.statusTwo && formik.errors.statusTwo ? (
                                        <div className="text-red-400 text-[12px] mt-[-15px] ml-1">{formik.errors.statusTwo}</div>
                                    ) : null} */}
            {formik.touched.statusTwo && formik.errors.statusTwo ? (
              <div className="text-red-400 text-[12px] mt-[-15px] ml-1">
                {formik.errors.statusTwo}
              </div>
            ) : null}

            <button
              type="submit"
              className="bg-primary-color text-white p-3 rounded-md font-semibold"
            >
              {t("register", "button")}
            </button>
          </div>
        </div>
      </form>
      {/* <Footer /> */}
    </div>
  );
};

export default Register;

/*
<div
                className={`w-full md:w-1/2 flex items-center justify-center bg-white ${styles.leftSide} hidden md:flex`}
            >
                <img src={register} alt="Register Illustration" className="object-cover self-end"/>
            </div>

            <div className={`w-full md:w-1/2 h-full flex items-center justify-center ${globalStyles.rightSide}`}>
                <div className="w-full max-w-md p-8 space-y-8">

                    <h1 className={`w-full text-5xl text-center text-white mb-10 ${globalStyles['poppins-regular']}`}>Perakende Kayıt Ol</h1>

                    <form className="space-y-8" onSubmit={formik.handleSubmit}>

                        <div className="relative">
                            <input
                                type="text"
                                id="name"
                                name="name"
                                placeholder="Adınız"
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white placeholder-white placeholder:font-bold focus:outline-none shadow-sm sm:text-sm ${styles['placeholder-bold']}`}
                                required
                            />
                            {formik.touched.name && formik.errors.name ? (
                                <div className="text-red-200 text-sm">{formik.errors.name}</div>
                            ) : null}
                        </div>

                        <div className="relative">
                            <input
                                type="text"
                                id="surname"
                                name="surname"
                                placeholder="Soyadınız"
                                value={formik.values.surname}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white placeholder-white placeholder:font-bold focus:outline-none shadow-sm sm:text-sm ${styles['placeholder-bold']}`}
                                required
                            />
                            {formik.touched.surname && formik.errors.surname ? (
                                <div className="text-red-200 text-sm">{formik.errors.surname}</div>
                            ) : null}
                        </div>

                        <div className="relative">
                            <input
                                type="email"
                                id="email"
                                name="email"
                                placeholder="E-Posta"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white placeholder-white placeholder:font-bold focus:outline-none shadow-sm sm:text-sm ${styles['placeholder-bold']}`}
                                required
                            />
                            {formik.touched.email && formik.errors.email ? (
                                <div className="text-red-200 text-sm">{formik.errors.email}</div>
                            ) : null}
                        </div>

                        <div className="relative">
                            <input
                                type="text"
                                id="phone"
                                name="phone"
                                placeholder="Telefon Numarası"
                                maxLength={10}
                                value={formik.values.phone}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white placeholder-white placeholder:font-bold focus:outline-none shadow-sm sm:text-sm ${styles['placeholder-bold']}`}
                                required
                            />
                            {formik.touched.phone && formik.errors.phone ? (
                                <div className="text-red-200 text-sm">{formik.errors.phone}</div>
                            ) : null}
                        </div>

                        <div className="relative">
                            <input
                                type="text"
                                id="address"
                                name="address"
                                placeholder="Adres"
                                value={formik.values.address}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white placeholder-white placeholder:font-bold focus:outline-none shadow-sm sm:text-sm ${styles['placeholder-bold']}`}
                                required
                            />
                            {formik.touched.address && formik.errors.address ? (
                                <div className="text-red-200 text-sm">{formik.errors.address}</div>
                            ) : null}
                        </div>

                        <div className="relative">
                            <input
                                type="text"
                                id="refCode"
                                name="refCode"
                                placeholder="Referans Kodu"
                                value={formik.values.refCode}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white placeholder-white placeholder:font-bold focus:outline-none shadow-sm sm:text-sm ${styles['placeholder-bold']}`}
                            />
                            {formik.touched.refCode && formik.errors.refCode ? (
                                <div className="text-red-200 text-sm">{formik.errors.refCode}</div>
                            ) : null}
                        </div>

                        <div className="relative">
                            <input
                                type="password"
                                id="password"
                                name="password"
                                placeholder="Şifre"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white placeholder-white placeholder:font-bold focus:outline-none shadow-sm sm:text-sm ${styles['placeholder-bold']}`}
                                required
                            />
                            {formik.touched.password && formik.errors.password ? (
                                <div className="text-red-200 text-sm">{formik.errors.password}</div>
                            ) : null}
                        </div>

                        <div className="relative">
                            <input
                                type="password"
                                id="confirmPassword"
                                name="confirmPassword"
                                placeholder="Şifreyi Doğrula"
                                value={formik.values.confirmPassword}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white placeholder-white placeholder:font-bold focus:outline-none shadow-sm sm:text-sm ${styles['placeholder-bold']}`}
                                required
                            />
                            {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
                                <div className="text-red-200 text-sm">{formik.errors.confirmPassword}</div>
                            ) : null}
                        </div>

                        <div className="relative flex items-start flex-col">
                            <div className=' flex'>
                                <div className="flex items-center h-5">
                                    <input
                                        id="status"
                                        name="status"
                                        type="checkbox"
                                        checked={formik.values.status}
                                        onChange={(e: any) => {
                                            formik.handleChange(e);
                                            localStorage.setItem('checkboxStatus', e.target.checked); 
                                        }}
                                        className="focus:ring-black h-4 w-4 text-black border-gray-300 rounded"
                                    />
                                </div>
                                <div className="ml-3 text-sm text-white">
                                    <label htmlFor="status" className="font-medium text-gray-700">
                                        <span onClick={() => handleNavigate("/contracts/privacy_and_security_policy")}
                                            className="text-white hover:underline cursor-pointer">Gizlilik ve Güvenlik Politikası'nı</span> okudum
                                        ve kabul ediyorum.
                                    </label>
                                </div>
                            </div>

                            <div className=' flex'>
                                <div className="flex items-center h-5">
                                    <input
                                        id="statusTwo"
                                        name="statusTwo"
                                        type="checkbox"
                                        checked={formik.values.statusTwo}
                                        onChange={(e: any) => {
                                            formik.handleChange(e);
                                            localStorage.setItem('checkboxStatus', e.target.checked); 
                                        }}
                                        className="focus:ring-black h-4 w-4 text-black border-gray-300 rounded"
                                    />
                                </div>
                                <div className="ml-3 text-sm text-white">
                                    <label htmlFor="status" className="font-medium text-gray-700">
                                        <span onClick={() => handleNavigate("/contracts/distance_selling_contract")}
                                            className="text-white hover:underline cursor-pointer">Mesafeli Satış Sözleşmesi'ni</span> okudum
                                        ve kabul ediyorum.
                                    </label>
                                </div>
                            </div>

                            <div className=' font-bold'>
                            {formik.touched.statusTwo && formik.errors.statusTwo ? (
                                <div className="text-red-200 text-sm">{formik.errors.statusTwo}</div>
                            ) : null}
                            </div>
                        </div>

                        {error && <div className="text-red-200 text-sm">{error == 'User already exists' ? '' : error == 'Invalid phone number' ? 'Telefon numarası geçersiz.' : null}</div>}

                        <div>
                            <button
                                type="submit"
                                className={`w-full py-2 px-4 border border-transparent text-sm font-medium rounded-md text-primary-color bg-white hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white ${styles['submit-button']}`}
                            >
                                Kayıt Ol
                            </button>
                        </div>
                    </form>

                    <div className="text-center">
                        <button
                            className="text-white font-bold"
                            onClick={() => handleNavigate('/login')}
                        >
                            Zaten hesabınız var mı? Giriş Yapın
                        </button>
                    </div>
                </div>
            </div>
*/
